module.exports = __webpack_public_path__ + "assets/img/d4636aad843fa7797008715078fb3399.png";